/**
 * Generic CSV download utility
 */

/**
 * Escape a field for CSV format
 * @param {*} field - Field value to escape
 * @returns {string} Escaped field
 */
const escapeCSVField = (field) => {
  if (field === null || field === undefined) return "";
  const str = String(field);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * Download data as CSV file
 * @param {Array<Array>} data - 2D array of data (rows and columns)
 * @param {string} filename - Name of the file to download
 */
export const downloadCSV = (data, filename) => {
  const csv = data.map((row) => row.map(escapeCSVField).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};
